import parseCoords from 'coord-parser';
import round from 'lodash/round.js';
import {fromLonLat, transformExtent} from 'ol/proj.js';
import {GEO_PROJECTION, WGS84_PROJECTION} from '../constants.js';

export function latLonToString(latLon) {
  const [lat, lon] = latLon.map(coord => round(coord, 2));
  const ns = lat >= 0 ? 'N' : 'S';
  const ew = lon >= 0 ? 'E' : 'W';
  return `${Math.abs(lat)}° ${ns}, ${Math.abs(lon)}° ${ew}`;
}

export function latLonFromString(string) {
  let latLon = null;
  try {
    const coords = parseCoords(string);
    if (
      coords.lat >= -90 &&
      coords.lat <= 90 &&
      coords.lon >= -180 &&
      coords.lon <= 180
    ) {
      latLon = [coords.lat, coords.lon].map(
        value => Math.round(value * 1e8) / 1e8,
      );
    }
    // eslint-disable-next-line no-unused-vars
  } catch (err) {
    // Pass through
  }
  return latLon;
}

export function searchLatLon(query) {
  const results = [];

  const latLon = latLonFromString(query);
  if (latLon) {
    const lonLat = latLon.slice().reverse();
    const center = fromLonLat(lonLat);
    const buffer = 5e3;
    const extent = [
      center[0] - buffer,
      center[1] - buffer,
      center[0] + buffer,
      center[1] + buffer,
    ];

    const text = latLonToString(latLon);
    results.push({
      id: text,
      text,
      place_name: text,
      bbox: transformExtent(extent, WGS84_PROJECTION, GEO_PROJECTION),
    });
  }

  return results;
}
